// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1aGrn","orderId":"style_orderId__2_sAu","spinning":"style_spinning__x24n9"};